import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrossInCircleFilled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM3.88899 5.11085L5.10881 3.89134L7.99975 6.78153L10.8824 3.89799L12.1019 5.11783L9.21957 8.00104L12.1082 10.889L10.8884 12.1085L8.00009 9.22088L5.117 12.1048L3.89752 10.885L6.78027 8.00138L3.88899 5.11085Z",
		fill: "#E30613"
	})]
});
const ForwardRef = forwardRef(SvgCrossInCircleFilled);
export { ForwardRef as ReactComponent };
